import { render, staticRenderFns } from "./across_fourth.vue?vue&type=template&id=7d1521e8&scoped=true&"
import script from "./across_fourth.vue?vue&type=script&lang=js&"
export * from "./across_fourth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1521e8",
  null
  
)

export default component.exports